export default __webpack_public_path__ + "static/media/Structure Model.cf078579.m4v";